// extracted by mini-css-extract-plugin
export default {"container":"lib-component-mappings-sky-parallax-components-Feature-Ornamentation-hubCardNoDescription__container--ekkT_"};